import { ShippingManifestDestinationCorrectionBoxValue } from "./shipping-manifest-destination-correction-form.value";

const boxFields: Array<keyof ShippingManifestDestinationCorrectionBoxValue> = [
  "boxNumber",
  "length",
  "width",
  "height",
  "weight",
];

export default function hasCorrectionBoxChanged(
  current: ShippingManifestDestinationCorrectionBoxValue = {},
  draft: ShippingManifestDestinationCorrectionBoxValue = {}
): boolean {
  return boxFields.some(
    (field) => (current[field] ?? "") !== (draft[field] ?? "")
  );
}
